// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__1KovP","title":"Navbar_title__3ylfe","logoContainer":"Navbar_logoContainer__3WmWg","logo":"Navbar_logo__3jRV6","hamburger":"Navbar_hamburger__20qCt"};